import React from 'react';
import { render } from 'react-dom';
import Main from './react-main';

export default () => render(<Main />, document.getElementById('pavrunner'))
